export enum RitualActionTypes {
    API_RESPONSE_SUCCESS = '@@rituals/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@rituals/API_RESPONSE_ERROR',

    GET_RITUALS = '@@rituals/GET_RITUALS',
    GET_RITUAL_BY_ID = '@@rituals/GET_RITUAL_BY_ID',
    ADD_RITUAL = '@@rituals/ADD_RITUAL',
    UPDATE_RITUAL = '@@rituals/UPDATE_RITUAL',
    DELETE_RITUAL = '@@rituals/DELETE_RITUAL',

    TAG_SERVICE_TO_RITUALS = '@@rituals/TAG_SERVICE_TO_RITUALS',
    TAG_PRODUCT_TO_RITUALS = '@@rituals/TAG_PRODUCT_TO_RITUALS',

    ASSIGN_RITUAL_TO_POOJARI = '@@rituals/ASSIGN_RITUAL_TO_POOJARI',
    GET_RITUALS_BY_POOJARI = '@@rituals/GET_RITUALS_BY_POOJARI',
    GET_POOJARIS_BY_RITUAL = '@@rituals/GET_POOJARIS_BY_RITUAL',
    UPDATE_POOJARI_RITUAL = '@@rituals/UPDATE_POOJARI_RITUAL',
    REMOVE_RITUAL_FROM_POOJARI = '@@rituals/REMOVE_RITUAL_FROM_POOJARI',

    BULK_IMPORT_RITUALS = '@@rituals/BULK_IMPORT_RITUALS',
    RESET_IMPORT_STATE  = '@@rituals/RESET_IMPORT_STATE',

    RESET = '@@rituals/RESET'
}
